<div class="row col-12 p-0 m-0 main-page-section ">
  <!-- <div class="p-0">
            <app-side-nav [item]="meetingNav"></app-side-nav>
        </div> -->
  <div class="col-12 p-0 employee-section">
    <!-- <app-header></app-header> -->
    <div class="col-height">

      <div>

        <div class="breadcrumbs-section pl-2 ml-5">
          <span class="prev-page pr-2 prev" routerLink="/overview">Home</span>
          <img src="../../assets/images/seperator.png">
          <span class="curr-page pl-2 breadcrumbs-section-font current">VMS Invitation Rights</span>
        </div>

        <div class="history-layout">

          <div class="row">
            <div class="col-12">
              <h1>VMS Invitation Rights</h1>
            </div>
          </div>


        </div>


        <div class="col-12 d-flex justify-content-between row borders m-0 p-0 ">
          <div class="col-3  borders-right d-flex justify-content-between relative-content ml-0 pl-0">

            <div class="pt-3 pb-3" (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'"
              [ngbPopover]="popMeetingRooms" triggers="manual" #p1="ngbPopover" (click)="openPopover(p1)"
              placement="bottom" popoverClass='dash-popover dashboard-popover'
              class=" meeting-label center-align box-size pointer-link text-center meeting-room-head">
              <div class="text">Request Status</div>
              <img src="../../assets/images/Path.png" class="pr-3 access-point-arrow" loading="lazy" />
              <div class="font"> {{multiSelectionCompanyName.length>1?selectedCompanyName+" +"+
                selctionlength :selectedCompanyName}}</div>

              <div>
                <ng-template #popMeetingRooms>
                  <div class="dashboard-popover ">
                    <div class="">
                      <div class="">
                        <div class="row pb-3 d-flex justify-content-between pointer-link"
                          *ngFor="let item of List;let i=index" (click)="selectCompanyName(item);"
                          [class]="multiSelectionCompanyName.includes(item?.id) ?'bold-font':'normal-font'">
                          {{item.name}}
                          <div>
                            <img src="/assets/images/tick.png"
                              *ngIf="multiSelectionCompanyName.includes(item?.id) || (item?.id == null && multiSelectionCompanyName.length == 0)"
                              class="pl-5 " loading="lazy" />
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                </ng-template>
              </div>
            </div>

          </div>


          <div class=" pt-3 pb-3 borders-right col-2 ">

            <div class="pl-3">
              <span class="meeting-label pt-3" style="
                            position: absolute;
                            padding-left: 31px;margin-top: -14px;">From</span>

              <input class="cal-icon all-hosts pt-3  pointer-link" (click)="d1.toggle()" [(ngModel)]="fDate"
                ngbDatepicker #d1="ngbDatepicker" (dateSelect)="updateSelectedDate($event)">

              <div class="meeting-sub-label from-date">{{formattedSelectedDate}}</div>

            </div>

          </div>
          <div class="pl-3 pt-3 pb-3 col-2 borders-right  ">
            <span class="meeting-label pt-3" style="
                            position: absolute;
                            padding-left: 31px;margin-top: -14px;">To</span>

            <input class="cal-icon all-hosts pt-3  pointer-link" (click)="d2.toggle()" [(ngModel)]="tDate" ngbDatepicker
              #d2="ngbDatepicker" (dateSelect)="updateSelectedToDate($event)">
            <div class="meeting-sub-label from-date">{{formattedSelectedToDate}}</div>

          </div>
          <div class="col-4"></div>

        </div>



        <div class="history-layout mt-4 pb-5 mb-5">

          <div class="row meeting-row mt-2 ml-0 " *ngFor="let item of historyList;let i=index;">

            <div (click)="navigateToDetail(item)" class="col-8 pl-4 pt-1">
              <div style="display: flex;" >
              <p class="name" *ngFor="let name of item?.name|slice:2-item?.name?.length"  >{{name}}<span >,</span></p><span *ngIf="item?.name?.length>2">+ {{item?.name?.length-2}} more</span>
            </div>
              <p class="detail">Invited on 22 mar,2021</p>
            </div>
            <div class="col-1"></div>
            <div class="col-2 place-end">
              <button class="orange-text pt-2">Approval awaited</button>
            </div>

            <div class="col-1 place-end">
              <div class="list-option pt-4" [id]="i+'__rights__'+item?.id"
              (click)="$event.stopPropagation();openDrawer(i+'__rights__'+item.id,item)">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="drawer-container">
                <div>
                  <p >Cancel</p>
                </div>
              </div>
            </div>
            </div>

          </div>


          <!-- <div class="d-flex justify-content-center pagination-section" *ngIf=" tempHistoryList?.length >10">
            <div class="row d-flex pagination-border">
              <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChange($event)"
              nextLabel="" class="d-flex justify-content-center">
            </pagination-controls>
              <div class="pr-3 ratio-class pt-1" *ngIf="historyList?.length>=10">10/{{tempHistoryList?.length}}</div>
            </div>
          </div> -->


        </div>

        <!-- <app-footer></app-footer> -->

      </div>
    </div>
